import * as SidebarActionTypes from '../../../constants/sidebar/ActionTypes';
import { PanelTypes, ModuleTypes } from '../../../constants/sidebar/DragAndDropTypes';
import update from 'immutability-helper'

const initialState = [];

export default (state = initialState, action) => {

    switch (action.type) {
        case SidebarActionTypes.INIT_SIDEBAR:
            return action.data.basicModules;

        case SidebarActionTypes.MOVE_IN_MODULE :

            if(action.panelName === PanelTypes.BASIC) {
                return update(state,
                    {
                        $splice : [[action.index, 0, action.module]]
                    }
                );
            }else{
                return state;
            }

        case SidebarActionTypes.MOVE_OUT_MODULE :
            if(action.panelName === PanelTypes.BASIC) {
                const module = (state.find((item, idx) => item.moduleId === action.moduleId));
                const moduleIndex = (state.findIndex((item, idx) => item.moduleId === action.moduleId));
                if(module.type=== ModuleTypes.NORMAL ){
                    return update(state,
                        {
                            $splice : [[moduleIndex, 1]]
                        }
                    );
                }
            }


        default:
            return state;
    }
}
